<div class="d-flex justify-content-center text-primary mt-5">
    <H2 class="mx-2 mt-5 mb-2">
        <i class="fas fa-user-slash"></i>
    </H2>
    <H1>Vous êtes désormais déconnecté</H1>
</div>